import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BannerComponent } from '../shared/components/banner/banner.component';
import { HeaderComponent } from '../shared/components/header/header.component';
import { LoadingCircularPanelComponent } from '../shared/components/loading-circular-panel/loading-circular-panel.component';

export const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CorePilotRoutingModule {
  static standaloneComponents = [
    HeaderComponent,
    BannerComponent,
    LoadingCircularPanelComponent
  ];
}
